import React, { createContext, useCallback, useContext, useState } from 'react';
import { useIntl } from 'react-intl';
import atatus from 'atatus';
import { Auth } from 'aws-amplify';
import { CUSTOM_AUTH_CHALLENGE, TOO_MANY_REQUEST_EXCEPTION, UNEXPECTED_ERROR } from 'constant/index';
import { tagForm } from 'tagManager';
const Context = createContext();

export const AuthProvider = ({ children }) => {
    const { formatMessage, locale } = useIntl();
    const [user, setUser] = useState(null);
    const [userMFASession, setUserMFASession] = useState(null);
    const [isFetchingUser, setFetchingStatus] = useState(false);
    const [forgotCredsUsername, setForgotCredsUsername] = useState('');
    const [userProfile, setUserProfile] = useState(null);

    const signIn = async (name, password) => {
        performance.mark('login');
        setFetchingStatus(true);
        try {
            const res = await Auth.signIn(name, password);

            if (res.challengeName === CUSTOM_AUTH_CHALLENGE) {
                if (res.challengeParam && res.challengeParam.errorCode === TOO_MANY_REQUEST_EXCEPTION) {
                    throw new Error('AttemptLimitExceeded');
                }
                if (res.challengeParam && res.challengeParam.errorCode === UNEXPECTED_ERROR) {
                    throw new Error('UnexpectedErrorOccured');
                }
                return setUserMFASession(res);
            }

            handleSuccessfullLogin(res);
        } finally {
            setFetchingStatus(false);
        }
    };

    const handleSuccessfullLogin = (authenticatedUser, isFromMFA = false) => {
        const {
            attributes: { sub: cognitoSubId },
            username,
        } = authenticatedUser;

        const transactionName = !isFromMFA ? 'Login' : 'Login-with-MFA';
        performance.measure('authenticated', 'login');
        const [{ duration }] = performance.getEntriesByName('authenticated', 'measure');
        atatus.recordTransaction(transactionName, duration);

        tagForm({
            fields: { username },
            name: 'login',
            success: true,
        });

        setUser({ cognitoSubId, username });
        setUserMFASession(null);
    };

    const signOut = useCallback(
        async (id) => {
            try {
                await Auth.signOut({ global: true });
            } finally {
                window.location.href = `/${locale}` + formatMessage({ id });
            }
        },
        [formatMessage, locale]
    );

    return (
        <Context.Provider
            value={{
                forgotCredsUsername,
                handleSuccessfullLogin,
                isFetchingUser,
                setForgotCredsUsername,
                setUser,
                setUserProfile,
                signIn,
                signOut,
                user,
                userMFASession,
                userProfile,
            }}
        >
            {children}
        </Context.Provider>
    );
};

const useAuth = () => useContext(Context);

export default useAuth;
